'use client'

import type { WelcomeBackPromotionSegment } from '@server/schemas'
import { useTranslation } from '@shared/config/i18n'
import { sendGA4CustomEvent } from '@shared/libs'
import Image from 'next/image'
import { ComponentProps } from 'react'

type Segment = WelcomeBackPromotionSegment
type BannerVariant = 'LOW' | 'MEDIUM'

type Props = {
  segment: Segment
  redirectUrl: string
  onClickWrapper: () => void
} & Partial<ComponentProps<typeof Image>>

const normalizeBannerVariant = (segment: Segment): BannerVariant => (segment === 'LOW' ? 'LOW' : 'MEDIUM')

const BANNER_CONFIG: Record<BannerVariant, { src: string; altKey: string }> = {
  LOW: {
    src: '/images/banners/welcomeback-low.png',
    altKey: 'homeBanners.alt.welcomeBackLow',
  },
  MEDIUM: {
    src: '/images/banners/welcomeback-medium.png',
    altKey: 'homeBanners.alt.welcomeBackMedium',
  },
}

export const WelcomeBackBanner = ({ segment, redirectUrl, onClickWrapper, ...props }: Props) => {
  const t = useTranslation()
  const config = BANNER_CONFIG[normalizeBannerVariant(segment)]

  const handleClick = () => {
    sendGA4CustomEvent('welcomeback_banner_click', {
      segment,
      redirect_url: redirectUrl,
    })
    onClickWrapper()
  }

  return (
    <header aria-label={`welcomeback-banner-${segment.toLowerCase()}`}>
      <button type="button" onClick={handleClick} className="w-full cursor-pointer border-0 bg-transparent p-0">
        <Image src={config.src} alt={t(config.altKey)} width={460} height={115} className="w-full h-auto" {...props} />
      </button>
    </header>
  )
}
